export default __webpack_public_path__ + "media/images/community/wordmark-universal-902c93ef8fcc531925bc714b2dc108e4.svg";